<div class="ml-2 flex items-center space-x-4 sm:ml-6 sm:space-x-6">
  <!-- Profile dropdown -->
  <div class="relative flex-shrink-0">
    <div class="flex items-center">

      <app-subscription-header class="hidden md:block"></app-subscription-header>

      <!-- New UI migration (Phase 1) -->
      <button *ngIf="uiMigration?.can_switch" type="button" (click)="switchToNewUi()" [disabled]="isSwitchingUi"
              class="mr-4 hidden md:inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white ring-1 ring-inset ring-white/30 hover:bg-white/20 disabled:opacity-60"
              id="try-new-ui">
        <span aria-hidden="true">&#10024;</span>
        {{ isSwitchingUi ? 'Opening…' : (uiMigration?.preferred_ui === 'new' ? 'Go to the new UI' : 'Try the new UI') }}
      </button>

      <button type="button" (click)="toggleUser()" class="-m-1.5 flex items-center p-1.5 hover:opacity-90" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
        <span class="sr-only">Open user menu</span>
        <img class="inline-block h-9 w-9 rounded-full" [src]="user.profile_photo || 'https://ui-avatars.com/api/?name=' + user.name + '&background=5046e5&color=fff'"
             (error)="onImageError($event)"
             alt="">
        <span class="hidden lg:flex lg:items-center">
        <svg class="ml-2 h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
        </svg>
      </span>
      </button>

    </div>

    <!--
      Dropdown menu, show/hide based on menu state.

      Entering: "transition ease-out duration-100"
        From: "transform opacity-0 scale-95"
        To: "transform opacity-100 scale-100"
      Leaving: "transition ease-in duration-75"
        From: "transform opacity-100 scale-100"
        To: "transform opacity-0 scale-95"
    -->
    <div *ngIf="isUserOpen" [@dropdownAnimation]="'visible'" class="absolute right-0 z-50 mt-2 w-48 origin-top-right bg-white rounded-xl shadow-lg  ring-none focus:outline-none p-2" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
      <!-- Active: "bg-gray-100", Not Active: "" -->
      <button routerLink="/settings/account" class="text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg w-full" role="menuitem" tabindex="-1" id="user-menu-item-0">Your Profile</button>
      <button type="button" (click)="openBillingPortal()" class="text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg w-full" role="menuitem" tabindex="-1" id="billing">Billing</button>
      <button *ngIf="uiMigration?.can_switch" type="button" (click)="switchToNewUi()" [disabled]="isSwitchingUi" class="text-left px-4 py-2 text-sm font-medium text-indigo-600 hover:bg-indigo-50 rounded-lg w-full" role="menuitem" tabindex="-1" id="try-new-ui-menu">&#10024; Try the new UI</button>
      <button (click)="signOut()" class="text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg w-full" role="menuitem" tabindex="-1" id="signout">Sign out</button>
    </div>
  </div>

  <!-- Language -->
  <div class="justify-center items-center relative hidden">

    <app-language-header></app-language-header>

  </div>

  <!-- Dark Mode -->
  <div class="flex justify-center items-center relative">

    <app-dark-mode-toggle class="rotate-90 relative left-[0.5rem]"></app-dark-mode-toggle>

  </div>
</div>
